// extracted by mini-css-extract-plugin
export default {"add":"control_add__Alm6X","tooltip":"control_tooltip__IU2-f"};